import { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import FleetOverview from "./pages/FleetOverview";
import TestRunsList from "./pages/TestRunsList";
import TestRunDetail from "./pages/TestRunDetail";
import HostManagement from "./pages/HostManagement";
import DeviceDetail from "./pages/DeviceDetail";
import HostDetail from "./pages/HostDetail";
import { JobLookup } from "./pages/JobLookup";
import Changelog from "./pages/Changelog";
import Roadmap from "./pages/Roadmap";
import Settings from "./pages/Settings";
import DeviceDisplay from "./pages/DeviceDisplay";

// Lazy-loaded: Scalar brings ~2 MiB of vendor code that most users never
// need. Keep it out of the main bundle so only `/docs` visitors pay for it.
const ApiDocs = lazy(() => import("./pages/ApiDocs"));

function LazyFallback() {
  return (
    <p
      style={{
        padding: "var(--space-xl)",
        color: "var(--color-text-secondary)",
      }}
    >
      Loading…
    </p>
  );
}

export default function App() {
  const { pathname } = useLocation();
  // The lifecycle wall page renders fullscreen on the phone itself and is
  // capability-authenticated in its own scoped protocol. Skip dashboard
  // chrome, sidebar, auth navigation, and the global event stream entirely.
  if (pathname.startsWith("/display/")) {
    return (
      <Routes>
        <Route path="/display/:sessionId" element={<DeviceDisplay />} />
      </Routes>
    );
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <main
        style={{
          marginLeft: "var(--sidebar-width)",
          flex: 1,
          padding: "var(--space-xl)",
          maxWidth: 1400,
        }}
      >
        <Routes>
          <Route path="/" element={<FleetOverview />} />
          <Route path="/runs" element={<TestRunsList />} />
          <Route path="/runs/:id" element={<TestRunDetail />} />
          <Route path="/hosts" element={<HostManagement />} />
          <Route path="/hosts/:id" element={<HostDetail />} />
          <Route path="/devices/:id" element={<DeviceDetail />} />
          <Route path="/jobs" element={<JobLookup />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route
            path="/docs"
            element={
              <Suspense fallback={<LazyFallback />}>
                <ApiDocs />
              </Suspense>
            }
          />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}
